import {object, SchemaOf, string} from 'yup';

import {EmailData} from '../types/EmailData';

export const $EmailData: SchemaOf<EmailData> = object({
  type: string().defined().nullable(),
  email: string().email().defined().nullable(),
});
